import { render, staticRenderFns } from "./RegisterBatys.vue?vue&type=template&id=49983938&scoped=true&"
import script from "./RegisterBatys.vue?vue&type=script&lang=js&"
export * from "./RegisterBatys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49983938",
  null
  
)

export default component.exports